import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { windowProvider } from '@inshared/shared/util';

/**
 * In de shared module worden modules geexporteerd die in (vrijwel) alle andere modules worden aangeroepen
 *
 * Services horen hier niet thuis, zie:
 * // TODO: klopt dit? volgens mij mogen er wel services in, maar moeten die in de forRoot worden opgegeven
 * https://angular.io/docs/ts/latest/cookbook/ngmodule-faq.html#!#q-why-bad
 */

@NgModule({
    imports: [],
    exports: [
        CommonModule,
        RouterModule,
    ],
    providers: [windowProvider],
})

/** @deprecated use the individual component modules from src/app/shared */
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
        };
    }
}
